import { derived } from 'svelte/store';
import { activityStore } from './activity';
import { areaStore } from './area';
import { offerStore } from './offer';
import { sessionStore } from './session';

export let canUseFastTrackOnboarding = derived(
	[activityStore, areaStore, offerStore, sessionStore],
	([$activityStore, $areaStore, _$offerStore, _$sessionStore]) => {
		return (
			$activityStore.filter((activity) => !activity.archivedAt).length <= 1 &&
			$areaStore.filter((area) => !area.archivedAt).length <= 1
		);
	}
);

export let hasConfigurationIssues = derived(
	[areaStore, sessionStore, offerStore],
	([$areaStore, $sessionStore, $offerStore]) => {
		return (
			$areaStore.filter((area) => !area.archivedAt).length === 0 ||
			$sessionStore.filter((session) => !session.archivedAt).length === 0 ||
			$offerStore.filter((offer) => !offer.archivedAt).length === 0
		);
	}
);
